import getUser from './getUser'
import Bibliotecarios from '../bibliotecas/Bibliotecarios'

const getBibliotecario = async () => {
  const user = await getUser()

  const { data } = await Bibliotecarios().show({
    'includes[user][id]': user.id,
    'includes[]': 'biblioteca'
  })

  if (data.data) {
    return data.data
  }
  return null
}
export default getBibliotecario
